<template>
  <header ref="appHeader" id="site-header" :class="{ 'visible': show }">
    <AppHeaderMobile v-if="isSmallScreen" />
    <AppHeaderDesktop v-else />
  </header>
</template>

<script>
import AppHeaderDesktop from '@/components/layout/AppHeaderDesktop.vue';
import AppHeaderMobile from '@/components/layout/AppHeaderMobile.vue';

export default {
  name: 'AppHeader',

  components: {
    AppHeaderDesktop,
    AppHeaderMobile,
  },

  data() {
    return {
      show: true,
      lastScrollTop: 0,
    };
  },

  computed: {
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },

  mounted() {
    this.lastScrollTop = this.getScrollPosition();
    window.addEventListener('scroll', this.peek);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.peek);
  },

  methods: {
    getScrollPosition() {
      const supportPageOffset = window.pageXOffset !== undefined;
      const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
      if (supportPageOffset) return window.pageYOffset;
      if (isCSS1Compat) return document.documentElement.scrollTop;
      return document.body.scrollTop;
    },

    peek() {
      const offset = 100;
      const scrollTop = this.getScrollPosition();
      const isScrollingDown = scrollTop > this.lastScrollTop;

      if (!isScrollingDown) {
        this.show = ((scrollTop < 100) || (scrollTop >= offset));
      } else {
        this.show = false;
      }

      this.lastScrollTop = (scrollTop <= 0) ? 0 : scrollTop;
    },
  },
};
</script>

<style lang="scss" scoped>
  #site-header {
    position: fixed;
    top: 1rem;
    left: 0;
    right: 0;
    padding: 0;
    margin: 0 auto;
    max-width: 1200px;
    opacity: 0;
    z-index: 10;
    background-color: $white;
    box-shadow: 0 0.5rem 1rem -0.5rem rgba($black, 0.1);
    transition: all 0.3s ease;
    transform: translateY(-200%);

    @include media ('<=tablet') {
      width: 100vw;
      top: 0;
      right: auto;
    }

    &.visible {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>
